import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';


/* KOMPONENTA BAR CHART ZA JEZIKE */
const LanguageBarChart = ({
  data,
  languageKey = 'Jezik',
  studentCountKey = 'Broj Ucenika'
}) => {
  const { t } = useTranslation();

  const translateLanguage = (language) => {
    switch (language) {
      case 'С':
      case 'Srpski':
        return t('statistic.serbian');
      case 'Х':
      case 'Hrvatski':
        return t('statistic.croatian');
      case 'М':
      case 'Mađarski':
        return t('statistic.hungarian');
      case 'Л':
      case 'Latinski':
        return t('statistic.latin');
      case 'Р':
      case 'Rumunski':
        return t('statistic.romanian');
      default:
        return language;
    }
  };
  const barData = data.map((item) => ({
    language: translateLanguage(item[languageKey]),
    count: parseInt(item[studentCountKey], 10)
  }));
  return (
    <Box
      sx={{ padding: '20px', backgroundColor: '#ffffff', borderRadius: '16px' }}
      height={600}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={barData}
          margin={{
            top: 50,
            right: 30,
            left: 20,
            bottom: 60
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="language"
            interval={0}
            label={{
              value: t('statistic.language'),
              position: 'insideBottom',
              offset: -10,
              dy: 15
            }}
          />
          <YAxis
            label={{
              value: t('statistic.studentCount'),
              angle: -90,
              position: 'insideLeft',
              dx: -20
            }}
            tickCount={8}
            domain={[0, 'auto']}
            interval={0}
          />
          <Tooltip formatter={(value) => [`${t('headers.total')}: ${value}`]} />
          <Legend
            formatter={() => t('statistic.totalCount')}
            wrapperStyle={{ marginTop: '50px', position: 'inherit' }}
          />
          <Bar dataKey="count" fill="#1f78b4" radius={[10, 10, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default LanguageBarChart;
